const isEnabledByDefault = value => value !== false;

export function hasExplicitMediaSharingConfig(config = {}) {
  return config?.mediaSharing !== undefined;
}

export function isCameraShareEnabled(config = {}) {
  if (hasExplicitMediaSharingConfig(config)) {
    return isEnabledByDefault(config?.mediaSharing?.camera?.enabled);
  }

  return isEnabledByDefault(config?.spawnCamera?.enabled);
}

export function isScreenShareEnabled(config = {}) {
  if (hasExplicitMediaSharingConfig(config)) {
    return isEnabledByDefault(config?.mediaSharing?.screenShare?.enabled);
  }

  return isEnabledByDefault(config?.spawnAndMoveMedia?.enabled);
}
